export const reducer = (state, action) => {
    switch (action.type) {
  
      case "USER_LOGIN": {
        return { ...state, isLogin: true , user: action.payload, token: action.token }
      }
      case "USER_LOGOUT": {
        return { ...state, isLogin: false , user: {} , token: "" } // set this to null on purpose, do not change
      }

      case "SET_USERS": {
        return { ...state, userList: action.payload }
      }

      case "SET_DROPDOWN": {
        return { ...state, getDropdowns: action.payload }
      }
       case "SET_MODAL_DATA": {
        return { ...state, ModalData: action.payload }
      }

      case "SET_IP": {
        return { ...state, ipAddress: action.payload } // set this to null on purpose, do not change
      }

      case "TIME_LOADER": {
        return { ...state, timeLoader: action.payload }
      }



      case "TIME_IN": {
        return { ...state, timeIn: action.payload, timeOut: "" } // set this to null on purpose, do not change
      }
      case "TIME_OUT": {
        return { ...state, timeIn: "", timeOut: action.payload, hrs: action.hours } // set this to null on purpose, do not change
      }




      case "CLICK_LOGOUT": {
        return { ...state, clickLoad: false } // set this to null on purpose, do not change
      }
      case "CLICK_LOGIN": {
        return { ...state, clickLoad: true } // set this to null on purpose, do not change
      }

      case "LOADING": {
        return { ...state, mainPageLoad: false } // set this to null on purpose, do not change
      }

      case "NOT_LOADING": {
        return { ...state, mainPageLoad: true } // set this to null on purpose, do not change
      }

      case "UPDATE_RELOAD_TIME": {
        return { ...state, reloadTime: 900000, reloadToggle: !state?.reloadToggle } // set this to null on purpose, do not change
      }

      case "CANCEL_RELOAD_TIME": {
        return { ...state, reloadTime: null } // set this to null on purpose, do not change
      }

      case "UPDATE_RAMZAN_POPUP": {
        return { ...state, ramzanPopup: action.payload }
      }
  
      
    //   case "TOGGLE_THEME": {mainPageLoad: false,
    //     return { ...state, darkTheme: !state.darkTheme } // set this to null on purpose, do not change
    //   }
  
      default: {
        return state
      }
    }
  }